import { render, staticRenderFns } from "./modalInfoClientes.vue?vue&type=template&id=67deac8d&"
import script from "./modalInfoClientes.vue?vue&type=script&lang=js&"
export * from "./modalInfoClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports